import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6a82120d = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "" */))

const _7923c480 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "" */))
const _419e2f63 = () => interopDefault(import('../pages/user/index.vue' /* webpackChunkName: "" */))
const _e24a5c40 = () => interopDefault(import('../pages/library/article/index.vue' /* webpackChunkName: "" */))
const _4f4b3ab9 = () => interopDefault(import('../pages/library/index.vue' /* webpackChunkName: "" */))
const _4712be42 = () => interopDefault(import('../pages/article/detail.vue' /* webpackChunkName: "" */))
const _5d64d4c2 = () => interopDefault(import('../pages/article/detail_simple.vue' /* webpackChunkName: "" */))
const _44058d00 = () => interopDefault(import('../pages/course/detail.vue' /* webpackChunkName: "" */))
const _0d508415 = () => interopDefault(import('../pages/question/detail.vue' /* webpackChunkName: "" */))
const _6a95ee68 = () => interopDefault(import('../pages/question/detail_simple.vue' /* webpackChunkName: "" */))
const _0bcc49fc = () => interopDefault(import('../pages/knowledge/index.vue' /* webpackChunkName: "" */))
const _e2bb371a = () => interopDefault(import('../pages/course/index.vue' /* webpackChunkName: "" */))
const _b058731c = () => interopDefault(import('../pages/basic-course/index.vue' /* webpackChunkName: "" */))
const _6f20f33e = () => interopDefault(import('../pages/question/index.vue' /* webpackChunkName: "" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/learning/",
    component: _6a82120d,
    name: "home"
  }, {
    path: "/learning/index",
    redirect: {"name":"home"}
  }, {
    path: "/learning/search/index/keyword/:keyword",
    component: _7923c480,
    meta: {"defaultMode":"csr"},
    name: "search"
  }, {
    path: "/learning/search/show/keyword/:keyword",
    component: _7923c480,
    meta: {"defaultMode":"csr"},
    name: "search"
  }, {
    path: "/learning/search/show/tab/:tab/keyword/:keyword",
    component: _7923c480,
    meta: {"defaultMode":"csr"},
    name: "search-tab"
  }, {
    path: "/learning/search/show*",
    component: _7923c480,
    meta: {"defaultMode":"csr"},
    name: "search-click"
  }, {
    path: "/learning/search/index*",
    component: _7923c480,
    meta: {"defaultMode":"csr"},
    name: "search-index"
  }, {
    path: "/learning/user/index*",
    component: _419e2f63,
    meta: {"noWrap":true,"noPaddingTop":true,"needAuth":true,"csrOnly":true},
    name: "user"
  }, {
    path: "/learning/article/index/cg/:cgId?",
    component: _e24a5c40,
    name: "article-list"
  }, {
    path: "/learning/article/index",
    component: _4f4b3ab9,
    name: "article-index"
  }, {
    path: "/learning/article/index.html",
    component: _4f4b3ab9,
    name: "article-html"
  }, {
    path: "/learning/article/detail/id/:id",
    component: _4712be42,
    meta: {"noWrap":true,"noPaddingBottom":true},
    name: "article-detail"
  }, {
    path: "/learning/article/detail_simple/id/:id",
    component: _5d64d4c2,
    meta: {"noWrap":true,"noPaddingBottom":true},
    name: "article-detail-simple"
  }, {
    path: "/learning/preview/article/detail/id/:id",
    component: _4712be42,
    meta: {"noWrap":true,"noPaddingBottom":true},
    name: "article-detail-preview"
  }, {
    path: "/learning/course/detail/id/:id",
    component: _44058d00,
    name: "course-detail"
  }, {
    path: "/learning/preview/course/detail/id/:id",
    component: _44058d00,
    name: "course-detail-preview"
  }, {
    path: "/learning/question/detail/id/:id",
    component: _0d508415,
    name: "question-detail"
  }, {
    path: "/learning/article/simple/id/:id",
    component: _6a95ee68,
    name: "question-detail-simple"
  }, {
    path: "/learning/preview/question/detail/id/:id",
    component: _0d508415,
    name: "question-detail-preview"
  }, {
    path: "/learning/knowledge/index*",
    component: _0bcc49fc,
    name: "knowledge"
  }, {
    path: "/learning/course/index",
    component: _e2bb371a,
    name: "course-index"
  }, {
    path: "/learning/course/index.html",
    component: _e2bb371a,
    name: "course-html"
  }, {
    path: "/learning/course/index/cg/:cgId?",
    component: _e2bb371a,
    name: "course-video"
  }, {
    path: "/learning/office/index",
    component: _b058731c,
    name: "office-index"
  }, {
    path: "/learning/office/index.html",
    component: _b058731c,
    name: "office-html"
  }, {
    path: "/learning/office/index/cg/:cgId?",
    component: _b058731c,
    name: "basic-course"
  }, {
    path: "/learning/question/index",
    component: _6f20f33e,
    name: "question-index"
  }, {
    path: "/learning/question/index.html",
    component: _6f20f33e,
    name: "question-html"
  }, {
    path: "/learning/question/index/cg/:cgId?",
    component: _6f20f33e,
    name: "question"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
